import React, { useState, useEffect, useContext } from "react";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import JisEmptyList from "../../components/controls/emptylist";
import JisDialogForm from "../../components/formdialog";
import PdfViewer from "../../components/controls/pdfviewer";

function AffidavitPayments() {
  const { token, setIsExpired } = useContext(ShareContext);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");

  useEffect(() => {
    onLoad();
  }, []);

  const onLoad = async () => {
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/Payment/internal-receipts`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (Array.isArray(data)) {
        setPayments(
          data.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)),
        );
      } else if (data.code === -10) {
        setIsExpired(true);
      } else {
        setErr(data.status || "Failed to load payments");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
    }
  };

  return (
    <div>
      {payments?.length == 0 && !loading && <JisEmptyList />}
      {payments?.length > 0 && (
        <div className="table">
          <div className="table-header">
            <span>My Payments</span>
          </div>
          <div className="table-wrapper">
            <table className="case-details-table full-border">
              <thead>
                <tr>
                  <th>Ref</th>
                  <th>Pay Type</th>
                  <th>Amount (₦)</th>
                  <th>Status</th>
                  <th>Paid On</th>
                  <th>Created On</th>
                  <th>Receipt</th>
                </tr>
              </thead>
              <tbody>
                {payments.map((item, index) => (
                  <tr key={index}>
                    <td>{item.docref || "N/A"}</td>
                    <td>{item.payType || "N/A"}</td>
                    <td>{item.amount?.toLocaleString() || "N/A"}</td>
                    <td>{item.isPaid ? "Paid" : "Pending"}</td>
                    <td>
                      {item.paidOn
                        ? Constants.momentDate(item.paidOn).format(
                            "DD MMM, YYYY",
                          )
                        : "N/A"}
                    </td>
                    <td>
                      {item.createdOn
                        ? Constants.momentDate(item.createdOn).format(
                            "DD MMM, YYYY",
                          )
                        : "N/A"}
                    </td>
                    <td>
                      {item.isPaid && (
                       <>
                       <JisButton
                          variant="plain"
                          onClick={() => {
                            setIsPreview(true);
                            setPreviewUrl(
                              `${Constants.baseurl}/receipt-internal/${item.docref}`,
                            );
                          }}
                        >
                          Judiciary Receipt
                        </JisButton>
                      {item.receiptUrl!=null && <JisButton
                          variant="plain"
                          onClick={() => {
                            setIsPreview(true);
                            setPreviewUrl(
                              `${item.receiptUrl}`,
                            );
                          }}
                        >
                          Revenue Receipt
                        </JisButton>}  
                       </> 
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <BackLoader open={loading} />
      {isPreview && (
        <JisDialogForm title="Receipt" onClose={() => setIsPreview(false)}>
          <div style={{ height: "90vh" }}>
            <PdfViewer pdfUrl={previewUrl} />
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}

export default AffidavitPayments;
